import { HomeyAPI } from 'homey-api';

type AppUpdateSource = {
  origin?: unknown;
  state?: unknown;
  updateAvailable?: unknown;
};

type AppUpdateOptions = {
  api: HomeyAPI | null | undefined;
  app: AppUpdateSource | null | undefined;
};

export type AppUpdateAvailable = {
  version: string;
  permissions: string[];
};

export function getAppUpdateAvailable(
  app: AppUpdateSource | null | undefined,
): AppUpdateAvailable | null {
  const updateAvailable = app?.updateAvailable;

  if (isRecord(updateAvailable) === false) {
    return null;
  }

  if (typeof updateAvailable.version !== 'string') {
    return null;
  }

  const permissions: string[] = [];

  if (updateAvailable.permissions != null) {
    if (Array.isArray(updateAvailable.permissions) === false) {
      return null;
    }

    for (const permission of updateAvailable.permissions) {
      if (typeof permission !== 'string') {
        return null;
      }

      permissions.push(permission);
    }
  }

  return {
    version: updateAvailable.version,
    permissions,
  };
}

export function isAppUpdateAvailable(options: AppUpdateOptions): boolean {
  if (options.api == null || HomeyAPI.isHomeyAPIV3Cloud(options.api) || options.app == null) {
    return false;
  }

  if (options.app.origin !== 'appstore') {
    return false;
  }

  return getAppUpdateAvailable(options.app) != null;
}

export function isAppUpdateEligible(options: AppUpdateOptions): boolean {
  if (isAppUpdateAvailable(options) === false) {
    return false;
  }

  switch (options.app?.state) {
    case 'running':
    case 'crashed':
    case 'stopped':
      return true;
    default:
      return false;
  }
}

export function getAppUpdateInstallChannel(channel: string | null): string | undefined {
  switch (channel) {
    case 'live':
    case 'stable':
      return 'stable';
    case 'test':
    case 'beta':
      return 'beta';
    case 'alpha':
      return 'alpha';
    default:
      return undefined;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value != null;
}
